"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function ProductIcon() {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { d: "M3 7L10 7", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M14 7L21 7", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M3 17L12 17", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M16 17L21 17", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M10 4L10 10", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M16 14L16 20", stroke: "#2A3133", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
}
exports.default = ProductIcon;
